import React from 'react';

import { createPieChartDataset } from 'helpers/analytics';
import AnalyticsPieChart from './AnalyticsPieChart';

const PlansAnalytics = ({ plansAnalytics }) => {
  if (!plansAnalytics || !plansAnalytics.length) {
    return null;
  }

  const attMvnoDataset = createPieChartDataset(plansAnalytics, 'att', 'MVNO');
  const attTfwaDataset = createPieChartDataset(plansAnalytics, 'att', 'TFWA');
  const attVfwaDataset = createPieChartDataset(plansAnalytics, 'att', 'VFWA');
  const simoDataset = createPieChartDataset(plansAnalytics, 'simo', 'VFWA');

  return (
    <div>
      <div className="d-flex mar-b">
        {attMvnoDataset && Boolean(attMvnoDataset.length) && (
          <div>
            <p
              style={{ fontSize: '18px', marginBottom: '0px' }}
              className="flex-justify-center"
            >
              AT&T MVNO
            </p>
            <AnalyticsPieChart
              dataset={attMvnoDataset}
              width={460}
              height={320}
            />
          </div>
        )}
        {attTfwaDataset && Boolean(attTfwaDataset.length) && (
          <div>
            <p
              style={{ fontSize: '18px', marginBottom: '0px' }}
              className="flex-justify-center"
            >
              AT&T TFWA
            </p>
            <AnalyticsPieChart
              dataset={attTfwaDataset}
              width={460}
              height={320}
            />
          </div>
        )}
      </div>
      <div className="d-flex mar-b">
        {attVfwaDataset && Boolean(attVfwaDataset.length) && (
          <div>
            <p
              style={{ fontSize: '18px', marginBottom: '0px' }}
              className="flex-justify-center"
            >
              AT&T VFWA
            </p>
            <AnalyticsPieChart
              dataset={attVfwaDataset}
              width={460}
              height={320}
            />
          </div>
        )}
        {simoDataset && Boolean(simoDataset.length) && (
          <div>
            <p
              style={{ fontSize: '18px', marginBottom: '0px' }}
              className="flex-justify-center"
            >
              Simo VFWA
            </p>
            <AnalyticsPieChart dataset={simoDataset} width={460} height={320} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlansAnalytics;
